import { getEnvironmentConfig } from 'app-components/utils/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import 'utils/core/configInit'; // make sure to initialize config before using it

let fbMessaging = null;

const fbOptions = {
  appId: getEnvironmentConfig().firebase_app_id,
  apiKey: getEnvironmentConfig().firebase_api_key,
  messagingSenderId: getEnvironmentConfig().firebase_messaging_sender_id,
  projectId: getEnvironmentConfig().firebase_project_id,
};

// don't attempt to register if not supported in browser
const initFbMessaging = async () => {
  try {
    if (await isSupported()) {
      const firebaseApp = initializeApp(fbOptions);
      fbMessaging = getMessaging(firebaseApp);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize Firebase Messaging', err);
  }
};

initFbMessaging();

export const messaging = fbMessaging;
